<template>
  <div class="page">
    <div class="content_box">
      <div class="message_box">
        <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          success-text="刷新成功"
          :disabled="errorFlag"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text="没有更多了"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="onLoad"
          >
            <div
              class="message_item msg-list-item"
              :class="index === 0 ? 'first' : ''"
              v-for="(item, index) in messageList"
              :key="item.id"
              @click="goDetail(item)"
            >
              <div class="img-wrap">
                <img class="type-icon" :src="item.setIcon" />
                <div class="is-read" v-if="item.is_not_read"></div>
              </div>
              <div class="right-wrap">
                <div class="msg-top-layout">
                  <div class="type-name">{{ item.setTypename }}</div>
                  <div class="message-time">{{ item.setShowtime }}</div>
                </div>
                <div class="message-content">{{ item.content }}</div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as utils from '../../api/utils'
import * as common from '../../api/common'
import * as constant from '../../api/constant'

import { Toast } from 'vant'
export default {
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      errorFlag: false,
      pageOption: {
        total: 0,
        page_no: 1,
        page_size: 15,
        res_page_no: 0
      },
      messageList: []
    }
  },
  mounted () {
    this.queryList()
    this.$store.dispatch('MSGBADGEACTION')
  },
  computed: {},
  methods: {
    toPiano (row) {
      this.$router.push({
        path: './appointmentDetails',
        query: {
          bookId: row.book_id,
          ismessage: 1,
          roomId: row.room_id,
          showTime: encodeURIComponent(row.set_useTime),
          showAddress: encodeURIComponent(row.set_address)
        }
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    formatNumber: function (n) {
      n = n.toString()
      return n[1] ? n : '0' + n
    },
    queryList () {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      const para = {
        page_no: this.pageOption.page_no,
        page_size: this.pageOption.page_size
      }
      api
        .axiosRequest(api.urlList.getMessageList, para)
        .then((res) => {
          console.log(res)
          // if (res === undefined) {
          //   return false
          // }
          if (res.code === common.resCode.OK) {
            if (res.list && res.list.length > 0) {
              res.list.forEach((item) => {
                let setIcon = ''
                let setTypename = ''
                let setShowtime = ''
                if (item.type === constant.announceType.usual) {
                  setIcon = require('../../assets/imgs/system_msg.png')
                  setTypename = '系统消息'
                } else if (item.type === constant.announceType.violate ||
                  item.type === constant.announceType.empty ||
                  item.type === constant.announceType.negative ||
                  item.type === constant.announceType.unLockDoor) {
                  setIcon = require('../../assets/imgs/punish_notice.png')
                  setTypename = '处罚通知'
                } else if (item.type === constant.announceType.fault) {
                  setIcon = require('../../assets/imgs/fault.png')
                  setTypename = '故障处理'
                } else if (item.type === constant.announceType.complaint) {
                  setIcon = require('../../assets/imgs/complaint.png')
                  setTypename = '意见反馈'
                } else if (item.type === constant.announceType.positive) {
                  setIcon = require('../../assets/imgs/award_notice.png')
                  setTypename = '奖励通知'
                } else if (item.type === constant.announceType.adminAward) {
                  setIcon = require('../../assets/imgs/admin_award.png')
                  setTypename = '表扬奖励通知'
                } else if (item.type === constant.announceType.cancelBookByCourse) {
                  setIcon = require('../../assets/imgs/cancel_book.png')
                  setTypename = '安排课程取消预约'
                } else if (item.type === constant.announceType.cancelBookAdmin) {
                  setIcon = require('../../assets/imgs/cancel_book.png')
                  setTypename = '管理员取消预约'
                } else if (item.type === constant.announceType.forceDown) {
                  setIcon = require('../../assets/imgs/system_msg.png')
                  setTypename = '系统消息'
                }

                if (item.create_time) {
                  let createTime = item.create_time

                  createTime = utils.formatDate(createTime)

                  // Toast(String(createTime))
                  const year = createTime.getFullYear()
                  const month = createTime.getMonth() + 1
                  const day = createTime.getDate()
                  const hour = createTime.getHours()
                  const minute = createTime.getMinutes()
                  // const second = createTime.getSeconds()
                  setShowtime = this.formatNumber(year) + '-' + this.formatNumber(month) + '-' + this.formatNumber(day) + ' ' + this.formatNumber(hour) + ':' + this.formatNumber(minute)
                }
                item.setIcon = setIcon
                item.setTypename = setTypename
                item.setShowtime = setShowtime

                // Toast(setShowtime)
              })
            } else {
              this.messageList = []
              this.finished = true
            }

            this.pageOption.total = res.total
            this.messageList.push(...res.list)
            this.loading = false
            this.refreshing = false
            Toast.clear()
            if (this.messageList.length >= this.pageOption.total) {
              this.finished = true
            }
          } else {
            this.error = true
            this.errorFlag = true
            this.loading = false
            this.refreshing = false
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          Toast.clear()
          console.log('error log:', e)
        })
    },
    onRefresh () {
      this.messageList = []
      this.finished = false
      this.loading = true

      this.onLoad()
    },
    onLoad () {
      // 监听到即执行
      console.log('滑到底了')

      if (this.refreshing) {
        // 下拉刷新
        this.pageOption.page_no = 1
        this.pageOption.res_page_no = 0
        this.queryList()
      } else {
        // 错误后点击刷新
        if (this.errorFlag) {
          // 说明上次加载失败 现在重新加载
          this.pageOption.page_no = 1
          this.errorFlag = false
          this.queryList()
          return false
        }
        // 触底加载
        if (this.messageList.length >= this.pageOption.total) {
          this.finished = true
        } else {
          this.pageOption.page_no = this.pageOption.page_no + 1
          this.queryList()
        }
      }
    },
    goDetail (item) {
      let dir = ''
      let todoUrl = ''

      if (item) {
        if (item && item.type === constant.announceTypes.usual.type) {
          dir = constant.announceTypes.usual.url
          todoUrl = constant.announceTypes.usual.url
        }
        if (item && item.type === constant.announceTypes.forceDown.type) {
          dir = constant.announceTypes.forceDown.url
          todoUrl = constant.announceTypes.forceDown.url
        }
        if (item && item.type === constant.announceTypes.complaint.type) {
          dir = constant.announceTypes.complaint.url
          todoUrl = constant.announceTypes.complaint.url
        }
        if (item && item.type === constant.announceTypes.fault.type) {
          dir = constant.announceTypes.fault.url
          todoUrl = constant.announceTypes.fault.url
        }
        // eslint-disable-next-line no-mixed-operators
        if (item && item.type === constant.announceTypes.violate.type ||
          item.type === constant.announceTypes.empty.type ||
          item.type === constant.announceTypes.negative.type ||
          item.type === constant.announceTypes.unLockDoor.type) {
          dir = constant.announceTypes.violate.url
          todoUrl = constant.announceTypes.violate.url
        }
        if (item && item.type === constant.announceTypes.positive.type) {
          dir = constant.announceTypes.positive.url
          todoUrl = constant.announceTypes.positive.url
        }
        if (item && item.type === constant.announceTypes.adminAward.type) {
          dir = constant.announceTypes.adminAward.url
          todoUrl = constant.announceTypes.adminAward.url
        }
        if (item && item.type === constant.announceTypes.cancelBookByCourse.type) {
          dir = constant.announceTypes.cancelBookByCourse.url
          todoUrl = constant.announceTypes.cancelBookByCourse.url
        }
        if (item && item.type === constant.announceTypes.cancelBookAdmin.type) {
          dir = constant.announceTypes.cancelBookAdmin.url
          todoUrl = constant.announceTypes.cancelBookAdmin.url
        }
      }

      if (item && dir && item.id) {
        // const url = `../viewMsg/${dir}/${dir}?id=${item.id}&type=${item.type}`

        this.$router.push({
          path: '/' + todoUrl,
          query: {
            id: item.id,
            type: item.type
          }
        })
      } else {
        Toast.fail('读取消息出错！')
      }
    }

  }
}
</script>
<style scoped lang="scss">
.page {
  padding-bottom: 3.75rem;
  .content_box {
    width: 100%;
    height: 100%;
    .message_box {
      height: 100%;
      padding: 1rem 0 4rem 0;
      .message_item {
        padding: 1rem;
        // background-color: #fafafa;
        margin-bottom: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .time {
          font-size: 18px;
          color: #333;
        }
        .floor {
          font-size: 14px;
          color: #666;
          margin-top: 0.5rem;
        }
        .right i {
          font-size: 1.875rem;
          color: #666;
        }
      }
      .msg-list-item {
        box-sizing: border-box;
        position: relative;
        margin-left: 1rem;
        margin-right: 1rem;
        margin-top: 0.3125rem;
        padding: 0.625rem 0;
        display: flex;
        align-items: center;
        border-bottom: #eee solid 1px;
      }
      .img-wrap {
        position: relative;
        width: 2.5rem;
        height: 2.5rem;
      }
      .is-read {
        position: absolute;
        top: -0.3125rem;
        right: -0.3125rem;
        width: 0.625rem;
        height: 0.625rem;
        border-radius: 50%;
        background-color: red;
      }
      .type-icon {
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 0.4375rem;
      }
      .right-wrap {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 3.125rem;
        box-sizing: border-box;
        justify-content: center;
        padding-right: 0.3125rem;
      }
      .msg-top-layout {
        display: flex;
        align-items: center;
      }
      .type-name {
        /* margin-left: 12rpx; */
        font-size: 1rem;
        font-weight: bold;
        color: #333;
      }
      .message-time {
        margin-left: auto;
        margin-right: 0.625rem;
        font-size: 0.75rem;
        color: #666;
      }
      .message-content {
        display: block;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 14px;
        color: #666;
      }
      .list-bottom-status-hint {
        width: 100%;
        height: 3.125rem;
        text-align: center;
        line-height: 3.125rem;
        color: #666;
        font-size: 15px;
      }
    }
  }
}
</style>
